import fetch from './AxiosAdapter';
import Configuracao from '../misc/Configuracao';
import { apresentarApiErroPadrao } from '@/utils/ApiErroPadraoUtils';

class ComentariosMinutaApi {

    getUrlComentarios(idProcesso, idTipoMinuta) {
        return Configuracao.urlMinutaGE + idProcesso + '/' + idTipoMinuta;
    }

    async buscar(idProcesso, idTipoMinuta, orgaoJulgador) {
        let result;
        try {
            result = await fetch(this.getUrlComentarios(idProcesso, idTipoMinuta) + '/comentarios?siglaOrgaoJulgador=' + orgaoJulgador);
        } catch (error) {
            console.error(result);
            if (apresentarApiErroPadrao(error)) {
                throw error;
            }
            throw new Error('Ocorreu um erro em sua solicitação. Por favor, tente novamente. Caso persista comunique ao administrador do sistema.');
        }
        if (result.status !== 200) {
            throw new Error('Não foi possível recuperar os comentários da minuta.');
        }
        const comentarios = result.data;
        // Ordena de forma decrescente
        comentarios.sort((comentario1, comentario2) => {
            if (comentario1.dataCriacao < comentario2.dataCriacao) {
                return 1;
            }
            if (comentario1.dataCriacao > comentario2.dataCriacao) {
                return -1;
            }
            return 0;
        });
        return comentarios;
    }

    async buscarMinutasComentadasDeTodosOsProcessos(idsProcesso: number[]): Promise<[number[]]> {//Promise<Map<number, number[]>> {
        if (idsProcesso.length) {
            const result = await fetch(`${Configuracao.urlProcessosGE}todos/minutas/todas/comentarios/minuta-comentada`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                data: idsProcesso
            });
            return result.data as any;
        }
        return [[]];
    }

    async salvar(idProcesso, idTipoMinuta, comentario) {
        let result;
        const numero = comentario.numero ? comentario.numero : '';
        try {
            result = await fetch(this.getUrlComentarios(idProcesso, idTipoMinuta) + '/comentarios/' + numero,
                {
                    method: comentario.numero ? 'PUT' : 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(comentario)
                });
            if (result.status === 404) {
                const json = result.data;
                if (json.mensagem.indexOf('Minuta inexistente') > -1) {
                    throw new Error('Por favor tente salvar a minuta antes de adicionar comentários. Não foi possível encontrar a minuta.');
                }
                throw new Error('Não foi possível encontrar o servidor. Tente novamente mais tarde ou contate o administrador do sistema.')
            }
        } catch (erro) {
            if (apresentarApiErroPadrao(erro)) {
                throw erro;
            }
            const message = "Não foi possível salvar o comentário. " + erro + " " + (result ? result.statusText : "");
            console.error(message);
            throw new Error(message);
        }
        return result;
    }

    async excluir(idProcesso: number, idTipoMinuta, numeroComentario) {
        let result;
        try {
            result = await fetch(this.getUrlComentarios(idProcesso, idTipoMinuta) + '/comentarios/' + numeroComentario,
                { method: 'DELETE' });
        } catch (erro) {
            if (apresentarApiErroPadrao(erro)) {
                throw erro;
            }
            const message = "Não foi possível excluir o comentário. " + erro + " " + (result ? result.statusText : "");
            console.error(message);
            throw new Error(message);
        }

        return result;
    }
}

export default new ComentariosMinutaApi();